<template>
  <Transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-confirm-container">
          <div class="modal-confirm-header">
            {{ t("SHARED.SESSION_TIMEOUT_MODAL_HEADER") }}
          </div>
          <div class="modal-confirm-body">
            <slot name="body"></slot>
          </div>
          <div class="modal-confirm-footer">
            <button
              id="confirm"
              class="modal-button btn btn-success"
              @click="confirm()"
            >
              {{ t("SHARED.SESSION_TIMEOUT_MODAL_CONFIRM") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "TimeoutModal",
  props: {
    minutesUntilTimeout: { type: Number, default: 1 },
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const milisecondsUntilTimeout = ref(props.minutesUntilTimeout * 60000);

    const timeout = ref();

    const confirm = () => {
      clearTimeout(timeout.value);
      emit("userIsStillHere", true);
    };

    const startTimer = () => {
      timeout.value = setTimeout(() => {
        emit("userIsStillHere", false);
      }, milisecondsUntilTimeout.value);
    };

    onMounted(() => {
      startTimer();
    });

    return { t, confirm };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-confirm-container {
  max-width: 500px;
  margin: 0 auto;
  padding: 20px 26px;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.modal-confirm-header {
  align-items: center;
  color: black;
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 33px;
  margin-bottom: 1em;
}

.modal-confirm-body {
  width: 100%;
  font-style: normal;
  font-weight: 400px;
  font-size: 16px;
  line-height: 24px;
  left: 0;
  right: 0;
  color: #000;
  margin-bottom: 1em;
}

.modal-confirm-footer {
  text-align: left;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-confirm-container,
.modal-leave-to .modal-confirm-container {
  transform: translateY(-20px);
  opacity: 0;
}

.modal-button {
  border-radius: 8px;
}

.btn-success {
  margin-top: 15px;
  color: white;
  background-color: $pj-color-green;
  border-color: $pj-color-green;
  width: 161px;
  height: 48px;

  &:hover {
    background-color: $pj-color-gray;
    border-color: $pj-color-gray;
  }
}
</style>
